module.exports = {
  // vuex-persistence keys
  STORAGE_VUEX_ARTIST_STOCK_METADATA_IMPORT_KEY: 'me:vuex:artist:stock_metadata_import',
  STORAGE_VUEX_ARTIST_STOCK_UPLOAD_KEY: 'me:vuex:artist:stock_upload',
};
